export class ACCMRICalculations {
    update(){

    }
}


// WEBPACK FOOTER //
// ./src/forms/accmri01/Calculations/ACCMRI-Calculations.js